module.exports = __webpack_public_path__ + "img/wx.b2b13a40.jpg";